import useState from 'states/generics/useState'
import useHttpPost from 'states/generics/useHttpPost'
import useUser from 'states/useUser'

export default function useUpdateDisplayName() {
  const url = `/auth/me/update`
  const { postInProgress, post } = useHttpPost({ url, sleep: 1000 })

  const updateProfile = async (data) => {
    const response = await post(data)
    const { setUserData } = useUser()
    setUserData(data)
    return response
  }

  return {
    updateProfile,
    postInProgress,
  }
}
